import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// components
import { Button } from '../../Shared';

ButtonsBlock.propTypes = {
  // from parent component
  addProduct: PropTypes.func,
  // from connect
  selected: PropTypes.array,
};

function ButtonsBlock({ addProduct, selected }) {
  const buttonDisabled = selected.filter((obj) => !!obj.value).map((product) => +product.name);

  return (
    <Button size="large" width={200} uppercase onClick={addProduct} disabled={!buttonDisabled.length}>
      Add attributes
    </Button>
  );
}

const mapDispatchToProps = (state) => ({
  selected: state.tableReducer.attributeTagging,
});

export default connect(mapDispatchToProps)(ButtonsBlock);
